import { definePreset } from '@openng/optimus-ui-themes';
import Aura from '@openng/optimus-ui-themes/aura';

const MyPreset = definePreset(Aura, {
    semantic: {
        // Densité compacte des contrôles de formulaire.
        // 15 composants dérivent leur padding de form.field (inputtext, textarea, select,
        // multiselect, autocomplete, cascadeselect, treeselect, inputchips, inputnumber...)
        // ainsi que p-button : une seule source pour tout resserrer.
        // Valeurs reprises de la variante `sm` d'Aura, donc sur une échelle qu'il valide déjà.
        formField: {
            paddingX: '0.625rem',
            paddingY: '0.375rem'
        },
        primary: {
            50: '{blue.50}',
            100: '{blue.100}',
            200: '{blue.200}',
            300: '{blue.300}',
            400: '{blue.400}',
            500: '{blue.500}',
            600: '{blue.600}',
            700: '{blue.700}',
            800: '{blue.800}',
            900: '{blue.900}',
            950: '{blue.950}'
        }
    },
    components: {
        inputgroup: {
            // Aura fige le padding de l'addon à 0.5rem (sans dériver de form.field) :
            // un groupe avec addon (€, %) dépassait de 4px les champs voisins.
            addon: {
                padding: '{form.field.padding.y} {form.field.padding.x}'
            }
        },
        button: {
            root: {
                // iconOnlyWidth ne dérive PAS de form.field : c'est son propre token, et il
                // sert aussi de hauteur aux boutons icon-only `rounded`. 2.25rem les aligne
                // sur les 38px des boutons texte au lieu de 40px.
                iconOnlyWidth: '2.25rem'
            }
        }
    }
});

export default MyPreset;